import { endContract } from "api/Employee";
import { useMutation } from "react-query";
import { toast } from "react-toastify";


export const useEndContract = () => {
    return useMutation(endContract, {
        onSuccess: () => {
            toast.success("Contract ended successfully!");
        },
        onError: (error: any) => {

            if (error.response?.data?.message) {
                toast.error(error.response?.data?.message);
                return
            }
            if (error.response?.data?.error) {
                toast.error(error.response?.data?.error);
                return
            }
            toast.error("Something went wrong! Please try again later.");
        },
    })
}